import { Affix } from 'antd';
import { Button, Checkbox, Col, Row } from '@/components/atoms';

export type TaxNoticeUploadFooterProps = {
  size: number;
  confirmable: boolean;
  loading: boolean;
  onClickDeleteAll: () => void;
  onClickConfirm: () => void;
};

const TaxNoticeUploadFooter = ({ size, confirmable, loading, onClickDeleteAll, onClickConfirm }: TaxNoticeUploadFooterProps) => {
  return (
    <Affix className="footer" offsetBottom={0}>
      <Row justify="space-between" style={{ background: '#f2f2f2', padding: '16px 4px' }}>
        <Col>
          <Button shape="round" type="default" disabled={size === 0} onClick={onClickDeleteAll}>
            전체삭제
          </Button>
        </Col>
        <Col>
          <Button shape="round" disabled={!confirmable} loading={loading} onClick={onClickConfirm}>
            {confirmable ? `${size}개의 고지서 등록` : '등록'}
          </Button>
        </Col>
      </Row>
    </Affix>
  );
};

TaxNoticeUploadFooter.defaultProps = {
  // TODO
};

export default TaxNoticeUploadFooter;
